import React from "react";
import styled from "styled-components";
import classNames from "classnames";

import { BUCKETS, BUCKET_COLORS } from "constants/satisfaction/data";

const KEY_METRICS = {
  NPS_SCORE: "npsScore",
  TOTAL_RESPONSES: "responseCount",
  QUALITATIVE_RESPONSES: "qualitativeCount",
  TOTAL_SHOWN: "shownCount",
  RESPONSE_RATE: "responsePercentage"
};

const KEY_METRICS_ROW = [
  KEY_METRICS.NPS_SCORE,
  KEY_METRICS.TOTAL_RESPONSES,
  KEY_METRICS.RESPONSE_RATE,
  KEY_METRICS.TOTAL_SHOWN,
  KEY_METRICS.QUALITATIVE_RESPONSES
];

const KeyMetrics = props => {
  const {
    npsScore,
    responseCount,
    shownCount,
    qualitativeCount,
    className
  } = props;

  const responsePercentage = responseCount
    ? `${Math.round(100 * (responseCount / shownCount))}%`
    : 0;

  let keyMetricsDataElements = {
    [KEY_METRICS.NPS_SCORE]: {
      label: "NPS Score",
      value: npsScore && !isNaN(npsScore) ? npsScore : 0
    },
    [KEY_METRICS.TOTAL_RESPONSES]: {
      label: "Total Responses",
      value: responseCount
    },
    [KEY_METRICS.RESPONSE_RATE]: {
      label: "Response Rate",
      value: responsePercentage
    },
    [KEY_METRICS.TOTAL_SHOWN]: {
      label: "Total Shown",
      value: shownCount
    },
    [KEY_METRICS.QUALITATIVE_RESPONSES]: {
      label: "Qualitative Responses",
      value: qualitativeCount
    }
  };

  const scoreClass =
    keyMetricsDataElements[KEY_METRICS.NPS_SCORE].value < 0
      ? "detractor"
      : keyMetricsDataElements[KEY_METRICS.NPS_SCORE].value === 0
      ? "neutral"
      : "promoter";

  const keyMetricsResults = KEY_METRICS_ROW.map((metric, i) => {
    return (
      <div
        key={`${metric}-${i}`}
        className={classNames(
          "result",
          metric,
          metric === KEY_METRICS.NPS_SCORE && scoreClass
        )}
      >
        <div className="value">{keyMetricsDataElements[metric].value}</div>
        <div className="name">{keyMetricsDataElements[metric].label}</div>
      </div>
    );
  });

  return (
    <div className={classNames("resultsContainer", className)}>
      {keyMetricsResults}
    </div>
  );
};

export default styled(KeyMetrics)`
  display: flex;
  width: 100%;
  flex-direction: row;
  border: 2px solid ${props => props.theme["$gray-1"]};
  border-radius: 6px;

  .result {
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
    font-family: ${props => props.theme["$font-body"]};
    flex-grow: 1;
    width: 100%;

    .value {
      font-weight: 200;
      font-size: 64px;
      color: ${BUCKET_COLORS[BUCKETS.NEUTRALS].color};
    }

    .name {
      font-weight: 300;
      color: ${props => props.theme["$gray-30"]};
    }

    /* TODO: Unsure if this is used any longer. */
    .responseCount {
      border: 2px solid ${props => props.theme["$gray-1"]};
      border-left: none;
      padding-bottom: 39px;
    }

    &:first-child {
      padding: 20px 55px;
      background-color: ${props => props.theme["$gray-1"]};
      border-right: 2px solid ${props => props.theme["$gray-1"]};

      .value {
        font-size: 96px;
        color: ${BUCKET_COLORS[BUCKETS.NEUTRALS].color};
      }

      &.detractor .value {
        color: ${BUCKET_COLORS[BUCKETS.DETRACTORS].color};
      }

      &.promoter .value {
        color: ${BUCKET_COLORS[BUCKETS.PROMOTERS].color};
      }

      .name {
        font-size: 23px;
        font-weight: 500;
        margin-bottom: 15px;
      }
    }
    &:not(:first-child) .value {
      margin-top: 25px;
    }
    &:last-child {
      padding-right: 25px;
    }
  }
`;
